export default [
  {
    id: 'b1000536-d092-4cca-b989-890f615070a0',
    path: 'timing-data-collection',
    name: 'timing-data-collection',
    meta: { title: '时序数据采集' },
    children: [
      {
        id: '3d610fd5-33e2-4c7f-896d-370efadaf617',
        path: 'config-management',
        name: 'config-management',
        component: () => {
          return import('../views/timingDataCollection/configManagement')
        },
        meta: {
          title: '接入配置管理',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
            read: {
              id: 5,
              name: 'read',
              desc: '查看',
              access: true,
            },
          },
        },
      },
      {
        id: '36ecde89-005d-4c8d-9061-6e87379ca19a',
        path: 'view-monitorPoint',
        name: 'view-monitorPoint',
        component: () => {
          return import('../views/timingDataCollection/viewMonitorPoint')
        },
        meta: {
          hidden: true,
          title: '监控测点详情',
        },
      },
      {
        id: '0f7a1178-c213-46c3-b164-b5ea69713940',
        path: 'opc-hda',
        name: 'opc-hda',
        component: () => {
          return import('../views/timingDataCollection/opcHda')
        },
        meta: {
          hidden: true,
          title: 'OpcHda',
        },
      },
      {
        id: '824a7a9d-4ebb-4794-9fd1-36f9a699b677',
        path: 'measuring-point-management',
        name: 'measuring-point-management',
        component: () => {
          return import('../views/timingDataCollection/measuringPointManagement')
        },
        meta: {
          title: '测点管理',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
            read: {
              id: 5,
              name: 'read',
              desc: '详情',
              access: true,
            },
          },
        },
      },
      {
        id: 'e3abe481-c699-4895-86fc-f7dee175bffd',
        path: 'data-view',
        name: 'data-view',
        component: () => {
          return import('../views/timingDataCollection/dataView')
        },
        meta: {
          title: '数据查看',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
          },
        },
      },
      {
        id: '5c43780d-98bc-4c90-a207-f1bff79b4840',
        path: 'historical-data',
        name: 'historical-data',
        component: () => {
          return import('../views/timingDataCollection/historicalData')
        },
        meta: {
          title: 'KAFKA历史数据重消费',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            export: {
              id: 3,
              name: 'export',
              desc: '导出',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
          },
        },
      },
    ],
  },
]
